import getCounselList from "./getCounselList";
import createCounsel from "./createCounsel";
import getCounsel from "./getCounsel";
import getCommentList from "./getCommentList";
import createComment from "./createComment";
import updateComment from "./updateComment";
import deleteComment from "./deleteComment";

export default {
  getCounselList,
  createCounsel,
  getCounsel,
  getCommentList,
  createComment,
  updateComment,
  deleteComment,
};
